module.exports = __webpack_public_path__ + "static/media/CSM148.8a8cc7e1.PNG";